import { render, staticRenderFns } from "./HistorialMovimientosItemDialogComponent.vue?vue&type=template&id=20a4ebcd"
import script from "./HistorialMovimientosItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./HistorialMovimientosItemDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports